import './App.css'
import PropTypes from 'prop-types'
import * as Sentry from '@sentry/react'
import { BrowserRouter } from 'react-router-dom'
import ApplicationRoutes from './ApplicationRoutes.jsx'
import ErrorFallback from './common/components/ErrorFallback.jsx'
import useAuthRuntime from './common/hooks/useAuthRuntime.js'
import useMicrofrontendStyleScope from './common/hooks/useMicrofrontendStyleScope.js'

const SentryFallback = ({ error, resetError }) => <ErrorFallback error={error} resetError={resetError} />

SentryFallback.propTypes = {
  error: PropTypes.instanceOf(Error).isRequired,
  resetError: PropTypes.func.isRequired,
}

function AppContent() {
  useAuthRuntime()
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <ApplicationRoutes />
    </BrowserRouter>
  )
}

function App() {
  useMicrofrontendStyleScope()
  return (
    <Sentry.ErrorBoundary fallback={SentryFallback}>
      <div className="mfe-root mfe-informes-root w-full" data-microfrontend="informes" data-mode="standalone">
        <AppContent />
      </div>
    </Sentry.ErrorBoundary>
  )
}

export default App
